import { html, LitElement } from "lit";

export class WelcomeUser extends LitElement {
  static properties = {
    user: { type: Object, attribute: "user" },
    signOutRoute: { type: String, attribute: "sign-out-route" },
    signOutLabel: { type: String, attribute: "sign-out-label" },
  };

  constructor() {
    super();
    this.user = {};
    this.signOutRoute = "/sign-out";
    this.signOutLabel = "Sign Out";
  }

  render() {
    return html`
        <p>Signed in as <b>${this.user?.displayName}</b></p>
        <p><a href="${this.signOutRoute}">${this.signOutLabel}</a></p>
    `;
  }
}

customElements.define("welcome-user", WelcomeUser);
